import { Component, Input } from '@angular/core';

@Component({
    selector: 'influencer-module-container',
    templateUrl: './influencer-module-container.component.html',
    styleUrls: ['./influencer-module-container.component.scss']
})
export class InfluencerModuleContainerComponent {
    @Input() printMode: boolean;
    @Input() height = 'auto';
    @Input() useAbsolutePositionHeader: boolean;

    @Input() title: string;
    @Input() tooltip: string;

    @Input() isFetchingData: boolean;
    @Input() hasNoData: boolean;

    @Input() placeholderWidth = 360;
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-module-container/influencer-module-container.component.ts